import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    // ================= Partials =================

    SAVE_COMMENT: (substitutionId) => ({
        url: `substitutions/${substitutionId}/comments`,
        method: "post",
    }),

    SAVE_SHIFT_DATA: {
        url: "verzoeken/save-shift-data",
        method: "post",
    },

    UPDATE_DAY_PART_STATUS: {
        url: "verzoeken/update-day-part-status",
        method: "post",
    },

    UPDATE_WTF: {
        url: "verzoeken/scherm/updateWtf",
        method: "post",
    },

    GET_LONG_CONTRACT_ADMIN_LIST: {
        url: "verzoeken/long-contract/admin-list",
        method: "post",
    },

    SAVE_LONG_CONTRACT: {
        url: "verzoeken/long-contract/save",
        method: "post",
    },

    UPDATE_LONG_CONTRACT: {
        url: "verzoeken/long-contract/update",
        method: "post",
    },

    GET_LONG_CONTRACT_DETAILS: {
        url: "verzoeken/long-contract/details",
        method: "post",
    },

    MELDER_REMINDER: {
        url: "verzoeken/melder-reminder",
        method: "post",
    },

    GET_ARCHIVED_MESSAGES: {
        url: "verzoeken/archived-messages",
        method: "post",
    },

    REMOVE_USER: {
        url: "verzoeken/remove-user",
        method: "post",
    },

    DELETE_DAY_PART: {
        url: "verzoeken/delete-day-part",
        method: "post",
    },

    COMMENT_STATUS: (id) => ({
        url: `substitutions/${id}/comments`,
        method: "post",
    }),
    COMMUNITY_LIST: {
        url: "/communities",
        method: "get",
    },

    SCHOOLS: (communityId) => ({
        url:
            communityId && communityId !== 0
                ? `schools-list?iCommunityId=${communityId}`
                : "schools",
        method: "get",
    }),

    ABSENT_CODES: (communityId) => ({
        url: `planboard/absent-code-list/${communityId}`,
        method: "get",
    }),

    CONTRACT_TYPES: (communityId) => ({
        url: `planboard/contract-type/${communityId}`,
        method: "get",
    }),

    ABSENTS_LIST: (queryString) => ({
        url: `planboard?${queryString}`,
        method: "get",
    }),
};

// ================= Partials Hooks =================

export const useSaveComment = (substitutionId) =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_COMMENT(substitutionId));

export const useSaveShiftData = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_SHIFT_DATA);

export const useUpdateDayPartStatus = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_DAY_PART_STATUS);

export const useUpdateWtf = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_WTF);

export const useGetLongContractAdminList = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_LONG_CONTRACT_ADMIN_LIST);

export const useSaveLongContract = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_LONG_CONTRACT);

export const useUpdateLongContract = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_LONG_CONTRACT);

export const useGetLongContractDetails = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_LONG_CONTRACT_DETAILS);

export const useMelderReminder = () =>
    useApiFetcherSWR(API_ENDPOINT.MELDER_REMINDER);

export const useGetArchivedMessages = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_ARCHIVED_MESSAGES);

export const useRemoveUser = () =>
    useApiFetcherSWR(API_ENDPOINT.REMOVE_USER);

export const useDeleteDayPart = () =>
    useApiFetcherSWR(API_ENDPOINT.DELETE_DAY_PART);

export const useCommunityList = () =>
    useApiFetcherSWR(API_ENDPOINT.COMMUNITY_LIST);

export const useSchools = (communityId) =>
    useApiFetcherSWR(
        ["schools", communityId],
        () => API_ENDPOINT.SCHOOLS(communityId)
    );



export const useAbsentCodes = (communityId) =>
    useApiFetcherSWR(
        communityId ? ["absent-codes", communityId] : null,
        () => API_ENDPOINT.ABSENT_CODES(communityId)
    );


export const useCommentStatus = (id) =>
    useApiFetcherSWR(API_ENDPOINT.COMMENT_STATUS(id));

export const useContractTypes = (communityId) =>
    useApiFetcherSWR(
        communityId ? ["contract-types", communityId] : null,
        () => API_ENDPOINT.CONTRACT_TYPES(communityId)
    );

export const usePlanboardAbsents = (queryString) =>
    useApiFetcherSWR(
        queryString ? ["planboard-absents", queryString] : null,
        () => API_ENDPOINT.ABSENTS_LIST(queryString)
    );

export default API_ENDPOINT;